import { MessageType } from 'kb-shared';
import gql from 'graphql-tag';

export interface CreateMessageMutationResponse {
  createMessage: { message: MessageType };
}

export const CREATE_MESSAGE_MUTATION = gql`
  mutation createMessage($conversationId: Int!, $body: String!) {
    createMessage(conversationId: $conversationId, body: $body) {
      message {
        id
        read
        body
        fromPatient
        createdAt
      }
    }
  }
`;
